"use client";

import { useEffect } from "react";

type PageHeadSyncProps = {
    title: string;
    description: string;
    canonicalUrl?: string;
    ogImage?: string;
    robots?: string;
};

/**
 * Синхронизация title / meta для клиентских лейаутов (App Router без next/head).
 * Не создаёт второй meta description — обновляет существующий.
 */
export function PageHeadSync({ title, description, canonicalUrl, ogImage, robots }: PageHeadSyncProps) {
    useEffect(() => {
        document.title = title;

        const setMeta = (attr: "name" | "property", key: string, content: string) => {
            const nodes = document.querySelectorAll(`meta[${attr}="${key}"]`);
            let el = nodes[0] as Element | undefined;
            if (!el) {
                el = document.createElement("meta");
                el.setAttribute(attr, key);
                document.head.appendChild(el);
            }
            // Аудиторы ругаются на дубли name=description
            for (let i = 1; i < nodes.length; i += 1) {
                nodes[i]?.parentNode?.removeChild(nodes[i]);
            }
            el.setAttribute("content", content);
        };

        setMeta("name", "description", description);
        if (robots) {
            setMeta("name", "robots", robots);
        }
        if (canonicalUrl && ogImage) {
            setMeta("property", "og:title", title);
            setMeta("property", "og:description", description);
            setMeta("property", "og:url", canonicalUrl);
            setMeta("property", "og:image", ogImage);
            setMeta("name", "twitter:title", title);
            setMeta("name", "twitter:description", description);
            setMeta("name", "twitter:image", ogImage);

            let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
            if (!link) {
                link = document.createElement("link");
                link.rel = "canonical";
                document.head.appendChild(link);
            }
            link.href = canonicalUrl;
        }
    }, [title, description, canonicalUrl, ogImage, robots]);

    return null;
}
